import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-assign-dialog',
  template: `
  <h3>{{data.head}}</h3>
    <hr>
    <p [innerHtml]="data.body.replace('##', data.item? '<strong>'+data.item+'</strong>': 'this item')"> </p>
    <div class="row a-center">
      <app-select-field class="col-9" [label]="data.head" [options]="data?.options"
      [control]="assignUser" valueKey="userId" optionKey="optionName" ></app-select-field> 
      <!-- [multiple]="!data.single" comment due to OA-125 -->
      <div class="col-3">
        <button mat-raised-button (click)="submit()" color="primary">Submit</button>
        <!-- <button mat-button (click)="onNoClick()" cdkFocusInitial class="ml-2">Cancel</button> -->
      </div>
    </div>
    <button class="close" mat-icon-button (click)="onNoClick()"><mat-icon>close</mat-icon></button>
    `,
  styles: ['.content-wrap{max-height:60vh;overflow-y:auto}',
    `:host{
      position: relative;
      display: block;
    }
    button.close{
      position:absolute;
      top:-10px;
      right:-10px;
    }`
  ]
})
export class AssignDialogComponent implements OnInit {

  assignUser = new FormControl('', Validators.required);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<AssignDialogComponent>) { }

  ngOnInit() {
    console.log("Data :::",this.data);
    if (this.data.assigned?.length) {
      this.assignUser.setValue(this.data.assigned.join(''));
    }
  }

  submit() {
    if (this.assignUser.valid) {
      this.dialogRef.close(this.assignUser.value);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
